// Ported from design_ideas/lernwelt/bundle.jsx — adventurer portrait stamps

export type AdventurerId = 'finn' | 'frida' | 'otto' | 'octi';

export interface Adventurer {
  id: AdventurerId;
  name: string;
  full: string;
  tagline: string;
  color: string;
  accent: string;
  voice: string;
  glyph: string;
  species: string;
  /** Single-character emoji used in buttons / labels ("Frag Finn" etc.). */
  emoji: string;
}

export const ADVENTURERS: Record<AdventurerId, Adventurer> = {
  finn: {
    id: 'finn',
    name: 'Finn',
    full: 'Finn der Fuchs',
    tagline: 'neugierig · verspielt',
    color: '#c96a2f',
    accent: '#f4cf94',
    voice: "Los geht's! Ich hab's fast geschafft!",
    glyph: 'F',
    species: 'Fuchs',
    emoji: '🦊',
  },
  frida: {
    id: 'frida',
    name: 'Frida',
    full: 'Frida die Füchsin',
    tagline: 'kreativ · einfühlsam',
    color: '#a8536b',
    accent: '#e9bcc5',
    voice: 'Stell dir vor… was wäre, wenn?',
    glyph: 'Fr',
    species: 'Füchsin',
    emoji: '🦊',
  },
  otto: {
    id: 'otto',
    name: 'Otto',
    full: 'Otto die Eule',
    tagline: 'weise · humorvoll',
    color: '#5d5d82',
    accent: '#cfccdf',
    voice: 'Hm… die Antwort liegt näher, als du denkst.',
    glyph: 'O',
    species: 'Eule',
    emoji: '🦉',
  },
  octi: {
    id: 'octi',
    name: 'Octi',
    full: 'Octi die Oktopus',
    tagline: 'verspielt · mag Muster',
    color: '#2f8a8a',
    accent: '#a8d5d5',
    voice: 'Acht Arme, acht Ideen — los geht\'s!',
    glyph: 'Oc',
    species: 'Oktopus',
    emoji: '🐙',
  },
};

interface Props {
  id?: AdventurerId;
  size?: number;
  active?: boolean;
  showLabel?: boolean;
}

export default function AdventurerStamp({ id = 'finn', size = 64, active = true, showLabel = false }: Props) {
  const a = ADVENTURERS[id];
  if (!a) return null;
  const s = size;

  const stripeSvg = `url("data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8'><path d='M-1,1 l2,-2 M0,8 l8,-8 M7,9 l2,-2' stroke='${a.accent}' stroke-width='1.2'/></svg>`
  )}")`;

  return (
    <div style={{
      position: 'relative',
      width: s, height: s,
      borderRadius: '50%',
      background: a.color,
      backgroundImage: stripeSvg,
      backgroundBlendMode: 'soft-light',
      boxShadow: active
        ? `0 2px 8px ${a.color}55, inset 0 0 0 2px ${a.accent}`
        : 'none',
      filter: active ? 'none' : 'grayscale(0.5) opacity(0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.2s',
      fontFamily: '"Fredoka", "Nunito", system-ui, sans-serif',
      fontWeight: 700,
      color: '#fff9ea',
      fontSize: s * 0.42,
      letterSpacing: '-0.02em',
      textShadow: '0 1px 2px rgba(0,0,0,0.25)',
      flexShrink: 0,
    }}>
      {a.glyph}
      {showLabel && (
        <div style={{
          position: 'absolute', top: '100%', left: '50%',
          transform: 'translateX(-50%)',
          marginTop: 6,
          fontFamily: '"JetBrains Mono", ui-monospace, monospace',
          fontSize: 9,
          fontWeight: 500,
          color: 'rgba(60,50,40,0.55)',
          textShadow: 'none',
          whiteSpace: 'nowrap',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
        }}>{a.species}</div>
      )}
    </div>
  );
}
